import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NameValue, ModalResult, ModalAnswer } from '../../models/shared.model';
import { SponsorDealerModel } from '../../models/sponsor-dealer.model';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AdaService } from '../../services/ada.service';
import { SponsorDealerService } from '../../services/sponsor-dealer.service';

@Component({
    selector: 'app-sponsor-dealer',
    templateUrl: './sponsor-dealer.component.html',
    styleUrls: ['./sponsor-dealer.component.scss'],
})
export class SponsorDealerComponent implements OnInit {

    @Input() states: Array<NameValue> = [];
    @Input() countries: Array<NameValue> = [];
    @Input() dealer: SponsorDealerModel = new SponsorDealerModel({});;
    @Input() visible = false;
    // @Output() dealerChange: EventEmitter<Dealer> = new EventEmitter<Dealer>();
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() formSubmit = new EventEmitter<SponsorDealerModel>();
    @Output() closeEvent = new EventEmitter<SponsorDealerModel>();

    dealerForm: FormGroup;
    submitted = false;
    errorMessages = {
        'companyName.required': 'Company Name is required',
        'email.required': 'Company Email is required',
        'email.email': 'Company Email is invalid',
        'contactFirstName.required': 'Primary Contact First Name is required',
        'contactLastName.required': 'Primary Contact Last Name is required',
        'contactTitle.required': 'Primary Contact Title is Required',
        'contactEmail.required': 'Primary Contact Email is required',
        'contactEmail.email': 'Primary Contact Email is invalid',
        'phone.required': 'Phone is required',
        'addressLine1.required': 'Address is required',
        'city.required': 'City is required',
        'state.required': 'State is required',
        'zip.required': 'Zip is required',
        'distributorName.required': 'Distributor Company Name is required',
        'distributorContactName': 'Distributor Primary Contact Name is required'
    };
    errors = [];

    constructor(private fb: FormBuilder, private _adaService: AdaService, private _sponsorDealerService: SponsorDealerService) {
    }

    ngOnInit() {
        this.createForm();
        this.dealerForm.patchValue(this.dealer);
        // this.dealerForm.get("contact").setValue(this.dealer.contact);
    }

    createForm() {
        this.dealerForm = this.fb.group(
            {
                companyName: ['', Validators.required],
                email: ['', [Validators.required, Validators.email]],
                companyPhone: ['', [Validators.required]],
                contactFirstName: ['', Validators.required],
                contactLastName: ['', Validators.required],
                contactTitle: ['', Validators.required],
                contactEmail: ['', [Validators.required, Validators.email]],
                addr1: ['', [Validators.required]],
                city: ['', [Validators.required]],
                state: ['', [Validators.required]],
                zip: ['', [Validators.required]],
                distributorName: ['', [Validators.required]],
                distributorContactName: ['', [Validators.required]]
            });
    }

    get dealerFormControl() {
        return this.dealerForm.controls;
    }

    // get contactControl() {
    //     return this.dealerForm.controls.contact.controls;
    // }

    onCancel() {
        this.visible = false;
        // this.visibleChange.emit(false);
        this.closeEvent.emit(this.dealer);
    }

    async onSubmit() {
        this.prepareValidationSummary();
        this.submitted = true;
        if (this.dealerForm.valid) {
            console.log("Got valid dealer form: ", this.dealerForm.value);
            this.dealer = this.dealerForm.value;
            console.log("Set Dealer: ", this.dealer);
            this.closeEvent.emit(this.dealer);
            console.table(this.dealerForm.value);
            //this.dealerForm.reset();
            this.submitted = false;
            this.dealer.isWaiting = true;
            //this.visibleChange.emit(false);

            await this._sponsorDealerService.postDealerSignUp(this.dealer)
                .then(
                    res => {
                        console.info("Success response: ", res);
                        this.dealer.confirmationMessage = (res as any).message;
                        this.dealer.isWaiting = false;
                        this.dealer.isSubmitted = true;
                        this.dealerForm.reset();
                    }
                ).catch(err => {
                    console.log(err);
                    this.dealer.isWaiting = false;
                    this.dealer.isErrored = true;
                    this.dealer.confirmationMessage = err.error.message;
                }
            );
        }
    }

    prepareValidationSummary() {
        this.errors.length = 0;
        for (const field in this.dealerForm.controls) { // 'field' is a string
            const control = this.dealerForm.get(field); // 'control' is a FormControl
            if (control.errors) {
                for (const error in control.errors) {
                    const key = field + '.' + error;
                    const x = this.errorMessages[key];
                    this.errors.push(x);
                }
            }
        }
    }

    whenPopupHidden(e) {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    get adaService() {
        return this._adaService;
    }


}





// WEBPACK FOOTER //
// ./src/app/shared/components/sponsor-dealer/sponsor-dealer.component.ts